import OutlookSettingsTab from "./outlook-settings";


export default OutlookSettingsTab;